import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigurationValuesComponent } from '../configuration/configuration-values/configuration-values.component';

import { ErrorComponent } from '../shared/error/error.component';
import { GeneralInformationComponent } from '../shared/general-information/general-information.component';
import { AccountSelectionComponent } from './account-selection/account-selection.component';
import { CheckDocumentInfoComponent } from './check-document-info/check-document-info.component';
import { ClientDataUpdateComponent } from './client-data-update/client-data-update.component';
import { DocumentsSendsComponent } from './documents-sends/documents-sends.component';
import { EmployedContractComponent } from './employed-contract/employed-contract.component';
import { ExpensesFormComponent } from './expenses-form/expenses-form.component';
import { FinancialIntroductionComponent } from './financial-introduction/financial-introduction.component';
import { ForeignCurrencyComponent } from './foreign-currency/foreign-currency.component';
import { ForeignProductsDetailComponent } from './foreign-products-detail/foreign-products-detail.component';
import { ForeignProductsComponent } from './foreign-products/foreign-products.component';
import { FormContactInfoComponent } from './form-contact-info/form-contact-info.component';
import { FormEmployeeComponent } from './form-employee/form-employee.component';
import { FormGoodsComponent } from './form-goods/form-goods.component';
import { FormSecondHeadlineInfoComponent } from './form-second-headline-info/form-second-headline-info.component';
import { FormUbicationInfoComponent } from './form-ubication-info/form-ubication-info.component';
import { GrayZoneComponent } from './gray-zone/gray-zone.component';
import { IdentificationSummaryComponent } from './identification-summary/identification-summary.component';
import { IncomeFormComponent } from './income-form/income-form.component';
import { IncomesSecondHeadlineComponent } from './incomes-second-headline/incomes-second-headline.component';
import { IndependentOccupationComponent } from './independent-occupation/independent-occupation.component';
import { InsurabilityComponent } from './insurability/insurability.component';
import { MaritalStatusComponent } from './marital-status/marital-status.component';
import { OccupationTcComponent } from './occupation-tc/occupation-tc.component';
import { OccupationComponent } from './occupation/occupation.component';
import { OfferComponent } from './offer/offer.component';
import { OperationCurrencyComponent } from './operation-currency/operation-currency.component';
import { PayDayFormTcComponent } from './pay-day-form-tc/pay-day-form-tc.component';
import { RequestConsultComponent } from './request-consult/request-consult.component';
import { ResidenceAbroadComponent } from './residence-abroad/residence-abroad.component';
import { SecondHeadlineComponent } from './second-headline/second-headline.component';
import { SuccessPcoComponent } from './success-pco/success-pco.component';
import { SupportDocumentsComponent } from './support-documents/support-documents.component';
import { UpdateDataComponent } from './update-data/update-data.component';
import { EdithOffertComponent } from './edith-offert/edith-offert.component';
import { VirtualCardFranchiseComponent } from './virtual-card-franchise/virtual-card-franchise.component';
import { FormNationalityComponent } from './form-nationality/form-nationality.component';

const routes: Routes = [
  {
    path: 'form-ubication-info',
    component: FormUbicationInfoComponent,
  },
  {
    path: 'occupation',
    component: OccupationComponent,
  },
  {
    path: 'residence-abroad',
    component: ResidenceAbroadComponent,
  },
  {
    path: 'marital-status',
    component: MaritalStatusComponent,
  },
  {
    path: 'check-document-info',
    component: CheckDocumentInfoComponent,
  },
  {
    path: 'retry-front-document-scan',
    component: ErrorComponent,
  },
  {
    path: 'rejected-prospect',
    component: ErrorComponent,
  },
  {
    path: 'identification-error',
    component: ErrorComponent,
  },
  {
    path: 'prospect-already-client',
    component: ErrorComponent,
  },
  {
    path: 'error-gotoOffice',
    component: ErrorComponent,
  },
  {
    path: 'prospect-is-pep',
    component: ErrorComponent,
  },
  {
    path: 'form-contact-info',
    component: FormContactInfoComponent,
  },
  {
    path: 'identification-summary',
    component: IdentificationSummaryComponent,
  },
  {
    path: 'financial-introduction',
    component: FinancialIntroductionComponent,
  },
  {
    path: 'form-employee',
    component: FormEmployeeComponent,
  },
  {
    path: 'form-unemployee',
    component: FormEmployeeComponent,
  },
  {
    path: 'form-employee-independent',
    component: FormEmployeeComponent,
  },
  {
    path: 'independent-occupation',
    component: IndependentOccupationComponent,
  },
  {
    path: 'income-form',
    component: IncomeFormComponent,
  },
  {
    path: 'goods-form',
    component: FormGoodsComponent,
  },
  {
    path: 'expenses-form',
    component: ExpensesFormComponent,
  },
  {
    path: 'operation-currency',
    component: OperationCurrencyComponent,
  },
  {
    path: 'foreign-currency',
    component: ForeignCurrencyComponent,
  },
  {
    path: 'foreign-products-detail',
    component: ForeignProductsDetailComponent,
  },
  {
    path: 'foreign-products',
    component: ForeignProductsComponent,
  },
  {
    path: 'gray-zone',
    component: GrayZoneComponent,
  },
  {
    path: 'insurability',
    component: InsurabilityComponent,
  },
  {
    path: 'employed-contract',
    component: EmployedContractComponent,
  },
  {
    path: 'offer',
    component: OfferComponent,
  },
  {
    path: 'support-documents',
    component: SupportDocumentsComponent,
  },
  {
    path: 'insurability',
    component: InsurabilityComponent,
  },
  {
    path: 'success-pco',
    component: SuccessPcoComponent,
  },
  {
    path: 'occupation-tc',
    component: OccupationTcComponent,
  },
  {
    path: 'pay-day-form-tc',
    component: PayDayFormTcComponent,
  },
  {
    path: 'error-rejected-time',
    component: ErrorComponent,
  },
  {
    path: 'client-data-update',
    component: ClientDataUpdateComponent,
  },
  {
    path: 'update-data',
    component: UpdateDataComponent,
  },
  {
    path: 'account-selection',
    component: AccountSelectionComponent,
  },
  {
    path: 'second-headline',
    component: SecondHeadlineComponent,
  },
  {
    path: 'general-data-information',
    component: GeneralInformationComponent,
  },
  {
    path: 'incomes-second-headline',
    component: IncomesSecondHeadlineComponent,
  },
  {
    path: 'form-second-headline-info',
    component: FormSecondHeadlineInfoComponent,
  }, {
    path: 'configuration-values',
    component: ConfigurationValuesComponent,
  },
  {
    path: 'request-consult',
    component: RequestConsultComponent,
  },
  {
    path: 'virtual-card-franchise',
    component: VirtualCardFranchiseComponent,
  },
  {
    path: 'documents-sends',
    component: DocumentsSendsComponent,
  },
  {
    path: 'edith-offer',
    component: EdithOffertComponent,
  },
  {
    path: 'form-nationality',
    component: FormNationalityComponent,
  },
  {
    path: 'account-selection-rotativo',
    component: AccountSelectionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class CaptureRoutes { }
